<template>
  <v-app>
    <v-container >
      <div class="display-1 mt-12" style="margin: 0 auto; max-width: 600px">
        <p>This site is now hosted at <a href="https://deltavmap.github.io">deltavmap.github.io</a></p>
        <br>
        <p>You will be redirected there shortly.</p>
      </div>
    </v-container>
  </v-app>
</template>
<script>

export default {
  name: 'App'
}
</script>
